const buyingQty = {
    stockInput: document.querySelector('.jsQtyInput') as HTMLInputElement,
    incQt: document.getElementById('incQt'),
    decQt: document.getElementById('decQt'),
    total: document.getElementById('jsTotalPrice') as HTMLElement,
    stockQty: 1,
    price: 0,
  
    init() {
      this.setInput();
      this.listenInput();
    },
  
    listenInput() {
      if (this.stockInput) {
        this.stockInput.addEventListener('change', () => {
          if (this.stockQty < 1) {
            this.stockInput.value = '1';
          }
        });
      }
    },
    setInput() {
      if (this.incQt && this.decQt) {
        this.decQt.addEventListener('click', () => {
          if (this.stockQty > 1) {
            this.stockQty--;
            this.stockInput.value = this.stockQty.toString();
          }
        });
  
        this.incQt.addEventListener('click', () => {
          this.stockQty++;
          this.stockInput.value = this.stockQty.toString();
        });
      }
    },
  };
  
  export default buyingQty;